var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-reference-container"},[_c('label',{staticClass:"control-label"},[_vm._v("Mês de Referência")]),_vm._v(" "),_c('Select',{attrs:{"showOptionEmpty":false,"options":_vm.references},on:{"input":_vm.update},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35aa49d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Escala/SelectReferencia.vue
// module id = 944m
// module chunks = 15